// Same rule as the backend (utils/objectCountingUtils.js): an object counts when
// it is new (isNewObject true or missing) and its picture shows a filling
// increase; diff_filling <= 0 means nothing was added.
export const isCountableObject = (segmentation, historyItem) => {
  if (!(Number(historyItem?.diff_filling) > 0)) return false;
  const hasIsNewObject = Object.hasOwn(segmentation || {}, "isNewObject");
  return segmentation?.isNewObject === true || !hasIsNewObject;
};
